/**
 * @module
 */

import {CONNECT, DESTROY} from '@acng/frontend-stargazer';
import {serviceWorker} from './service-worker.js';
import {isMobile} from './service/env.js';
import {goBack} from './service/location.js';
import {ClickController} from 'acng/layout/ctrl/click.js';
import {connect, disconnect} from 'acng/layout/service/size.js';

export const navigator = {
  desktop: !isMobile,
  mobile: isMobile,
  back: new ClickController(function () {
    goBack();
  }),
  class: {
    width: {
      [CONNECT]: connect,
      [DESTROY]: disconnect
    }
  },
  serviceWorker,
};
